import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { MachineService } from '../proxy/general/controllers/machine.service';
import { TractorCategoryService } from '../proxy/general/controllers/tractor-category.service';
import { TractorTypeService } from '../proxy/general/controllers/tractor-type.service';
import { TractorAttachmentPerTractor } from '@general/tractor-attachment-per-tractor/tractor-attachment-per-tractor';

FieldBuilder.setNamespace('General');

export const TRACTOR_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .checkbox('hasFlowMeter', 'Entity.Tractor.HasFlowMeter')
    .build(),
  FieldBuilder
    .checkbox('hasHighClearance', 'Entity.Tractor.HasHighClearance')
    .build(),
  FieldBuilder
    .number('teoricalConsumption', 'Entity.Tractor.TeoricalConsumption')
    .required()
    .decimal(2,18)
    .build(),
  FieldBuilder
    .number('horsePower', 'Entity.Tractor.HorsePower')
    .required()
    .decimal(2,18)
    .build(),
  FieldBuilder
    .foreignKey('tractorCategoryId', 'Entity.TractorCategory', TractorCategoryService)
    .required()
    .displayFromNested('tractorCategory.name')
    .sortBy('tractorCategory.name')
    .build(),
  FieldBuilder
    .foreignKey('tractorTypeId', 'Entity.TractorType', TractorTypeService)
    .required()
    .displayFromNested('tractorType.name')
    .sortBy('tractorType.name')
    .build(),
  FieldBuilder
    .foreignKey('machineId', 'Entity.Machine', MachineService)
    .required()
    .displayFromNested('machine.name')
    .sortBy('machine.name')
    .hideInChildForms()
    .build(),
];

export const TRACTOR_CONFIG = {
  entityName: 'Tractor',
  localizationKey: 'General::Entity.Tractor',
  fields: TRACTOR_FIELDS,
  permission: 'GeneralMachinesAndVehicles.Tractors',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.MachinesAndVehicles + MENU_NAME_SUFFIX,
  children: [
      {
        entityName: 'TractorAttachmentPerTractor',
        foreignKeyField: 'tractorId',
        localizationKey: 'General::Entity.TractorAttachmentPerTractor',
        component: TractorAttachmentPerTractor,
      },
  ]
};
